import PropTypes from 'prop-types';
import CorgixDialog from '@veeva/corgix/dialog';
import { css } from '@emotion/core';
import { isMobile } from '../services/DeviceInformation';

const propTypes = {
    actions: PropTypes.node,
    children: PropTypes.node,
    open: PropTypes.bool,
    title: PropTypes.node,
};

const Dialog = ({ children, title, actions, open = true }) => {
    return (
        <CorgixDialog
            css={({ white }) => [
                css`
                    border-radius: 8px;

                    header {
                        padding: 9px 12px 0;
                        margin: 0 0 20px;
                        height: fit-content;
                        border: none;
                        background-color: ${white};

                        & > div {
                            background-color: ${white};
                            height: fit-content;
                            line-height: 1.333rem;
                            font-size: 1.333rem;
                        }
                    }

                    & > div {
                        padding: 0 12px;
                        margin: 0 0 40px;
                        height: fit-content;
                        min-height: fit-content;
                    }

                    footer {
                        padding: 0 12px 12px;
                        button {
                            border-radius: 8px;
                            width: 100px;
                            height: 40px;
                            font-size: 16px;
                        }
                    }
                `,
                isMobile() &&
                    css`
                        footer {
                            button {
                                width: 160px;
                            }

                            button + button {
                                margin: 0 0 0 16px;
                            }
                        }
                    `,
            ]}
            open={open}
            actions={actions}
            title={title}
            draggable={false}
        >
            {children}
        </CorgixDialog>
    );
};

Dialog.propTypes = propTypes;

export default Dialog;
